module.exports = __webpack_public_path__ + "img/casino-map-pins.61c6f672.svg";